import { foundation } from '../../ui';
import Skeleton from './Skeleton';
import { components } from '../../ui/theme';

const sp = foundation.spacePx;
const cardTok = components.mobileDocument?.card;

/**
 * List loading placeholder — card rows (mobile) or table-ish rows (desktop).
 * Use only when `loading && items.length === 0` so refetches keep stale content.
 */
export default function ListRowSkeleton({
  rows = 5,
  layout = 'card',
  showAvatar = true,
  showTrailing = true,
  style: containerStyle,
  'aria-busy': ariaBusy = true,
}) {
  const indices = Array.from({ length: rows }, (_, i) => i);

  if (layout === 'table') {
    return (
      <div
        style={{ display: 'flex', flexDirection: 'column', gap: sp[2], ...containerStyle }}
        aria-busy={ariaBusy}
        aria-label="Loading"
      >
        {indices.map((i) => (
          <div
            key={i}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: sp[3],
              padding: `${sp[3]} ${sp[2]}`,
              borderBottom: `1px solid ${foundation.color.neutral.border}`,
            }}
          >
            {showAvatar ? <Skeleton width={56} height={12} borderRadius={foundation.radii.sm} /> : null}
            <Skeleton width={80} height={12} />
            <Skeleton width={110} height={12} />
            <Skeleton height={12} style={{ flex: '1 1 auto' }} />
            {showTrailing ? <Skeleton width={140} height={12} /> : null}
          </div>
        ))}
      </div>
    );
  }

  const cardStyle = {
    padding: cardTok?.padding ?? sp[3],
    borderRadius: cardTok?.borderRadius ?? foundation.radii.md,
    border: cardTok?.border ?? `1px solid ${foundation.color.neutral.border}`,
    background: cardTok?.background ?? foundation.color.neutral.surface,
    boxShadow: cardTok?.shadow,
  };

  return (
    <div
      style={{ display: 'flex', flexDirection: 'column', gap: sp[2], ...containerStyle }}
      aria-busy={ariaBusy}
      aria-label="Loading"
    >
      {indices.map((i) => (
        <div key={i} style={cardStyle}>
          <div style={{ display: 'flex', alignItems: 'center', gap: sp[2], minHeight: 44 }}>
            {showAvatar ? (
              <Skeleton width={24} height={24} borderRadius={foundation.radii.full} />
            ) : null}
            <div style={{ flex: 1, minWidth: 0 }}>
              <Skeleton width={`${55 + (i % 3) * 10}%`} height={10} borderRadius={6} />
              <Skeleton
                width={`${35 + (i % 2) * 8}%`}
                height={8}
                borderRadius={6}
                style={{ marginTop: 6 }}
              />
            </div>
            {showTrailing ? <Skeleton width={40} height={12} borderRadius={6} /> : null}
          </div>
        </div>
      ))}
    </div>
  );
}
